var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `${Shopify.currencySymbol}1` + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const purchaseOptions = document.querySelectorAll('.subscription-widget__option')
const subscriptionPlans = document.querySelectorAll('.selling__plan');
const form = document.querySelector('product-form form') || document.querySelector('[data-quickview-form-area] form[data-product-form]');
const variantIdInput = document.querySelector('product-form form input[name="id"]') || document.querySelector('[data-quickview-form-area] form[data-product-form] input[name="id"]');
let productJsonElement = document.querySelector('[data-product-json]');
let parsedProduct = productJsonElement ? JSON.parse(productJsonElement.textContent) : null;

const togglePurchaseType = event => {
    let target = event.target;
    let parent = target.closest('.subscription-widget__option');

    if (target.closest('.subscription-widget__option')) {
    purchaseOptions.forEach(el => {
        el == parent ? el.classList.add('active') : el.classList.remove('active')
    });
}

let type = document.querySelector('.subscription-widget__option.active').dataset.type;

// When switching to one-time, clear active state from all selling plans
if (type === 'onetime') {
    subscriptionPlans.forEach(el => el.classList.remove('active'));
}

    // NOTE: handleFreeGiftVisibility intentionally NOT called here
    // It is only called on ATC click, not on plan selection
    removeSelectPlanLabel();
    updateSellingPlan(type);
}

const removeSelectPlanLabel = () => {
    if (document.querySelector('.select-plan')) document.querySelector('.select-plan').classList.add('hidden');
}

const handleFreeGiftVisibility = (type) => {
    const freeGiftModal = document.getElementById('freeGiftFromPDP');
    if (!freeGiftModal) return;
    if (type === 'subscription') {
        freeGiftModal.classList.add('active');
        document.querySelectorAll('.shopify-section-group-group-header').forEach(el => el.style.display = 'none');
    }
}

const toggleSubscription = event => {
    let target = event.target;
    let parent = target.closest('.selling__plan');

    if (target.closest('.selling__plan')) {
        subscriptionPlans.forEach(el => {
            el == parent ? el.classList.add('active') : el.classList.remove('active')
        });
    }

    updateSellingPlan('subscription');
}

const updateSellingPlan = type => {
    let sellingPlanInput = document.querySelectorAll('product-form input[name="selling_plan"]');

    if (type == 'subscription') {
        let sellingPlanId = document.querySelector('.selling__plan.active').dataset.planId;
       
        if (sellingPlanInput.length > 0){
            sellingPlanInput.forEach(el => {
                el.setAttribute('value', sellingPlanId);
                el.removeAttribute('disabled');
            });
        }
    } else {
        if (sellingPlanInput.length > 0) sellingPlanInput.forEach(el => el.setAttribute('disabled', 'disabled'));
    }

    updatePrices();
}

const updatePrices = () => {
    let variantId = variantIdInput.value;
    let selectedVariant;
    let sellingPlanPrices = document.querySelectorAll('.selling_plan-price');
    
    let onetimerPrice = document.querySelector('.widget__option-price');
    let addToCartPrice = document.querySelectorAll('.atc-button-price');
    let type = document.querySelector('.subscription-widget__option.active')?.dataset.type || 'onetime';

    for (let variant of parsedProduct.variants) {
        if (variant.id == variantId) {
            selectedVariant = variant;
            break;
        }
    }

    if (type == 'onetime') {
        addToCartPrice.forEach(el => el.textContent = Shopify.formatMoney(selectedVariant.price));
        for (let sellingPlanPrice of sellingPlanPrices) {
            sellingPlanPrice.querySelector('span').textContent = Shopify.formatMoney(selectedVariant.selling_plan_allocations[0].per_delivery_price);
        }
    } else {
        let selectedSellingPlanId = document.querySelector('.selling__plan.active').dataset.planId;

        for (let plan of selectedVariant.selling_plan_allocations) {
            if (plan.selling_plan_id == selectedSellingPlanId ){
                addToCartPrice.forEach(el => el.textContent = Shopify.formatMoney(plan.per_delivery_price));
            }

            for (let sellingPlanPrice of sellingPlanPrices) {
                let sellingPlanPriceID = sellingPlanPrice.closest('.selling__plan').dataset.planId;
                
                if (sellingPlanPriceID == plan.selling_plan_id){
                    sellingPlanPrice.querySelector('span').textContent = Shopify.formatMoney(plan.per_delivery_price);
                }
            }
        }
    }

    onetimerPrice.textContent = Shopify.formatMoney(selectedVariant.price);

    updateMainPrices(selectedVariant, type)
}

const updateMainPrices = (variant, type) => {
    let mainPrice = document.querySelector('.product__price--main');
    let comparePrice = document.querySelector('.compare__price');
    let discountOffprice = document.querySelector('.product__price--off-amount:not(.disable__ajax)') || false;
    let amountOfPortions = +variant.title?.split(' ')[0];
    console.log(amountOfPortions);
    
    if (variant){
        let selectedVariantPrice = variant.price;

        if (type == 'subscription') {
            let selectedSellingPlanId = document.querySelector('.selling__plan.active').dataset.planId;
            for (let plan of variant.selling_plan_allocations) {
                if (plan.selling_plan_id == selectedSellingPlanId ){
                    selectedVariantPrice = plan.per_delivery_price;
                }
            }
        }

        mainPrice.textContent = Shopify.formatMoney(selectedVariantPrice);

        if (variant.compare_at_price != null) {
            comparePrice.textContent = Shopify.formatMoney(variant.compare_at_price);
        } else {
            comparePrice.textContent = '';
            discountOffprice.textContent = '';
        }
      
        if(discountOffprice) discountOffprice.textContent = Shopify.formatMoney(selectedVariantPrice / amountOfPortions);
    }
}

purchaseOptions.forEach(el => el.addEventListener('click', togglePurchaseType));
subscriptionPlans.forEach(el => el.addEventListener('click', toggleSubscription));
variantIdInput.addEventListener('change', updatePrices);
//variantIdInput.addEventListener('change', updateMainPrices);

// On load: deselect all options and show "SELECT YOUR PURCHASE PLAN" overlay
// Only runs on pages with the inline free-gift widget
document.addEventListener('DOMContentLoaded', () => {
    const freeGiftModal = document.getElementById('freeGiftFromPDP');
    if (!freeGiftModal) return; // Only run on free-gift products

    const atcButton = document.querySelector('.btn--add-to-cart');
    if (!atcButton) return;

    // Remove active from all options so nothing is pre-selected
    purchaseOptions.forEach(el => el.classList.remove('active'));

    // Add the "SELECT YOUR PURCHASE PLAN" overlay on the button
    const selectPlanEl = `<div class='select-plan'>${theme.widget.select_plan}</div>`;
    atcButton.insertAdjacentHTML('afterbegin', selectPlanEl);

    // Re-attach click handlers to remove overlay when user selects an option
    purchaseOptions.forEach(el => {
        el.addEventListener('click', () => {
            const overlay = document.querySelector('.select-plan');
            if (overlay) overlay.classList.add('hidden');
        });
    });
});

// Intercept ATC on free-gift products: open slipper modal instead of submitting if subscription selected
document.addEventListener('DOMContentLoaded', () => {
    const freeGiftModal = document.getElementById('freeGiftFromPDP');
    if (!freeGiftModal) return; // Only run on free-gift products

    const atcButton = document.querySelector('.btn--add-to-cart');
    if (!atcButton) return;

    atcButton.addEventListener('click', function(e) {
        const type = document.querySelector('.subscription-widget__option.active')?.dataset.type;
        if (type === 'subscription') {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleFreeGiftVisibility('subscription');
        }
        // if onetime, do nothing — form submits normally
    });
});